import React from 'react'
import { useContext } from 'react'

import type { TableContextValue } from '../../TableContext'
import TableContext from '../../TableContext'
import Cell, { SimpleCell } from '../Cell'

interface IRowProps {
  index: number
  isDragging?: boolean
  colIndex?: number | null
}

const getCells = (context: TableContextValue, i: number) => context.tableValue.cells[i]

const Row: React.FC<IRowProps> = ({ index: indexRow, isDragging, colIndex }) => {
  const ctx = useContext(TableContext)
  const cells = getCells(ctx, indexRow)

  return (
    <tr>
      {cells.map(
        (cell, index) =>
          cell &&
          (colIndex === undefined || colIndex === null || colIndex === index) &&
          (isDragging ? (
            <SimpleCell cell={cell} index={index} indexRow={indexRow} key={index} mode={ctx.mode} />
          ) : (
            <Cell cell={cell} index={index} indexRow={indexRow} key={index} />
          )),
      )}
    </tr>
  )
}

export default Row
